import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Table } from '../../../../common/table'
import EventEmitter, {
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { formatText } from '../../../../helpers/value'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'
import { TITLE_TABLE_SUGGEST_DETAIL } from '../constant'
import classes from '../index.module.scss'
import {
  getDataFromReduxDetails,
  getDataTableFromRedux,
  getLoadingInterested,
  selectIdsDetail,
  selectSuggest,
} from '../store/slice'
import { getSuggestionCompanyDetail } from '../store/thunk'
import { PopupAddToPort } from './PopupAddToPort'
import { SelectedCompany } from './SelectedCompany'
import { CustomTdCheckBox } from './schemaTabe/CustomTdCheckBox'
import { CustomThCheckBox } from './schemaTabe/CustomThCheckBox'

export const PopupDetailSuggest = ({ id, onClose }) => {
  const dispatch = useDispatch()

  const { height } = useViewport()

  const loading = useSelector(getLoadingInterested('suggestionDetailCompany'))
  const ids = useSelector(selectIdsDetail)
  const dataTable = useSelector(selectSuggest())
  const detailsSuggest = useSelector(getDataTableFromRedux(id))
  const userType = useSelector(selectUserType)

  const [isShow, setShow] = useState(false)

  const dataSelected = Object.values(dataTable).filter((item) => item?.check)

  const onSubmit = () => {
    if ([USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId)) {
      setShow(true)
    } else {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  useEffect(() => {
    dispatch(
      getSuggestionCompanyDetail({
        PortfolioId: id,
      }),
    )
  }, [])

  return (
    <>
      <PopupAction
        title="dashboard.suggestDetail.title"
        isShow={!!id}
        handleClose={onClose}
        btnSubmit={{
          label: 'dashboard.suggestDetail.addToPortfolio',
          event: onSubmit,
          isI18n: true,
          disabled: !dataSelected?.length,
        }}
        btnCancel={{
          label: 'dashboard.suggestDetail.cancel',
          event: onClose,
          isI18n: true,
        }}
        appendStyle={{
          width: 800,
          padding: '20px',
          backgroundColor: '#F3F3F3',
          borderRadius: '4px',
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <Element
              elementName="p"
              style={{
                paddingBottom: 13,
              }}
            >
              {formatText(detailsSuggest?.description)}
            </Element>
            {!!ids.length ? (
              <>
                <div className="dFlex justifyContentBetween">
                  <Element
                    style={{ borderColor: '#D9D9D9', width: '52%' }}
                    className={`${classes.tableRecommended}`}
                  >
                    <div className="w100">
                      <Table
                        ids={ids}
                        getDataFromRedux={getDataFromReduxDetails}
                        autoHeightMax={height * 0.7}
                        schema={TITLE_TABLE_SUGGEST_DETAIL.map((item) => {
                          return {
                            title: <CustomThCheckBox val={item.label} />,
                            colId: item.key,
                            tdStyle: {
                              padding: 0,
                            },
                            render: (val, { rowId }) => {
                              return (
                                <CustomTdCheckBox val={val} rowId={rowId} />
                              )
                            },
                          }
                        })}
                      />
                    </div>
                  </Element>
                  <div className={`${classes.panelSelect} flex1`}>
                    <div className="wh100">
                      <SelectedCompany data={dataSelected} />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Notification />
            )}
          </>
        )}
      </PopupAction>
      {isShow && (
        <PopupAddToPort
          isShow={isShow}
          setShow={setShow}
          functionClear={onClose}
        />
      )}
    </>
  )
}
